import React from 'react';
import { Clock, AlertCircle, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
export function UrgencySection() {
  const {
    t
  } = useLang();
  return <section className="py-24 bg-gold text-dark relative overflow-hidden" data-id="element-551" data-mp="36bio3mvwdrfz">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#000 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-552" data-mp="31hxz2kca87sx"></div>
      {/* Soft glow accents */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/20 rounded-full blur-3xl pointer-events-none" data-id="element-553" data-mp="3p8jtv9x9zvkz"></div>
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-dark/10 rounded-full blur-3xl pointer-events-none" data-id="element-554" data-mp="3l6yo08j5shka"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-555" data-mp="1uvkcpcd8ytbl">
        {/* Scarcity badge */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-dark text-white px-4 py-2 rounded-full text-sm font-bold mb-8 shadow-lg" data-id="element-556" data-mp="1qva4ru5w9su3">
          <span className="relative flex h-2.5 w-2.5" data-id="element-557" data-mp="37jc8io0r9pz0">
            <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-75 animate-ping" data-id="element-558" data-mp="3chxb2u3hclqm"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-gold" data-id="element-559" data-mp="3gihak4bj01fx"></span>
          </span>
          {t.urgency.badge}
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-560" data-mp="3lgirojpe5qor">
          {t.urgency.title}
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="space-y-3 text-lg md:text-xl font-medium mb-12 max-w-2xl mx-auto" data-id="element-561" data-mp="1k1mbrhkb7du4">
          <p data-id="element-562" data-mp="22zyqditzpfx3">{t.urgency.p1}</p>
          <p className="text-2xl font-black" data-id="element-563" data-mp="22yxbf39us9a3">{t.urgency.p2}</p>
          <p data-id="element-564" data-mp="2grdgsaq88je6">{t.urgency.p3}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="bg-dark text-white rounded-3xl p-8 md:p-10 shadow-2xl text-left" data-id="element-565" data-mp="2gq25zqyd6bdk">
          <div className="flex flex-col md:flex-row md:items-center gap-8" data-id="element-566" data-mp="35a5h9f3lgp5x">
            <div className="flex-1" data-id="element-567" data-mp="39cjwzqbyv8sz">
              <p className="text-xl mb-3" data-id="element-568" data-mp="39bikrij7sg9o">
                {t.urgency.offerA}{' '}
                <strong className="text-gold" data-id="element-569" data-mp="2vg6j0r6n5pj9">{t.urgency.offerPrice}</strong>{' '}
                {t.urgency.offerB}
              </p>
              <p className="text-gray-300 flex items-center gap-2" data-id="element-570" data-mp="2loitivtnaikf">
                <Clock className="w-5 h-5 text-gold shrink-0" data-id="element-571" data-mp="2lm6828oohq2m" />
                {t.urgency.clock}
              </p>
            </div>
            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center justify-center gap-2 px-8 py-4 bg-gold hover:bg-gold-400 text-dark font-bold rounded-full transition-all transform hover:scale-105" data-id="element-572" data-mp="2co49s0wbxbj1">
              <MessageCircle className="w-5 h-5" data-id="element-573" data-mp="27npxu7rlxhfq" />
              {t.urgency.cta}
            </a>
          </div>

          <div className="flex items-start gap-4 bg-white/5 p-5 rounded-xl border border-white/10 mt-8" data-id="element-574" data-mp="3b1htjygfp44w">
            <AlertCircle className="w-6 h-6 text-gold shrink-0" data-id="element-575" data-mp="362oisdsj7r8f" />
            <p className="text-sm text-gray-400" data-id="element-576" data-mp="31812313rs14e">
              <strong className="text-white" data-id="element-577" data-mp="2wash6sr8lizg">
                {t.urgency.importantLabel}
              </strong>{' '}
              {t.urgency.importantText}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}